module.exports = __webpack_public_path__ + "img/sfzzm.5d85d09b.png";